import { useSelector } from 'react-redux';

import { getLeadByVin } from 'redux-implementations/selectors';
import State from 'types/State';
import { Lead } from 'types/Apis/Lead';

export function useLeadByVin(vin: string): Lead | undefined {
  return useSelector((state: State) => getLeadByVin(state, vin));
}
